import React from "react";
import { getScheduleContractDetails } from "../../action/contract/getScheduleContractDetails";
import Loader from "../loader/loader";
import {
  CreatePaymentIntent
} from "../../action/card/paymentIntent";
import { getCardsDetails } from "../../action/cardDetails/cards";
import $ from 'jquery';
import { analyticsClickEvent } from "../../action/firebaseAnalytics/firebaseAnalytics";
import { Navigate, useLocation } from "react-router";
import { GTMUserIdAndLoginState } from "../../utils/GtmDatalayer";
import {PropTypes} from 'prop-types';
import withRouter from "../../withRouter";
import { getHolidayPeriod } from "../../action/contract/getHolidayPeriod";
import { formatDateToDDMMYY } from "../../utils/helpers/dateFormat";
import { frontEndLogs } from "../../action/logs/frontEndLogs";
import IndustryImage from "../dashboard/home/industryImage";
import { getUserContext } from "../../utils/helpers/storageUtils";


export class WalletContract extends React.Component {
  constructor(props) {
  
    super(props);
    this.state = {
      value: 0,
      contractId: "",
      contractDataDetails: "",
      contractScheduleDetails: "",
      nextPaymentDetails: "",
      convertednextPaymentDetails: "",
      isLoading: false,
      paymentMethodId: "",
      paymentIntentId: "",
      paymentAmount: "",
      currentBalanceAmount:"",
      payDate:"",
      selectedPaymentType:null,
      noContractMsg:'',
      redirect:false,
      hasActiveCards: [],
      holidayPeriodStatus: false,
      transactionAmount:"",
      transactionDate:"",
      contractNextInstallmentDate:"",
      contractLoanStatus:"",
      isEarlyPaymentDisabled:false,
      earlyPaymentMessage:""
    };
    this.child = React.createRef();
    this.goBack = this.goBack.bind(this);
    this.handleRangeChange = this.handleRangeChange.bind(this);
  }

  goBack(e) {
    analyticsClickEvent('wallet_back', '')
    this.props.navigate({pathname: "/wallet",state:{msg:this.child}});
  }
  handleRangeChange(event) {
    this.setState({ value: event.target.value });
  }

  componentDidMount() {
    if(sessionStorage.getItem('forwardRoute') !== '' && sessionStorage.getItem('forwardRoute') !== null){
      sessionStorage.removeItem('forwardRoute');
    }
    this.initialLoad();

    // Push the customer id and loginState if available on this page to the dataLayer
    window.dataLayer = window.dataLayer || {};
    GTMUserIdAndLoginState();
  }

  initialLoad = async () => {
    let contractId = this.props.location.state;
    this.setState({ contractId: contractId.contract_id })
    this.setState({ isLoading: true });
    let specificContractDetails = await getScheduleContractDetails(contractId);
    let holidayPeriodDetails = await getHolidayPeriod(contractId);
    let holidayPeriodStatus = false;
    let contractStartDate = null;
    let quickPaymentLink = null;

    if (holidayPeriodDetails.data.statusCode === 200) {
      const payload = holidayPeriodDetails.data.data;
      if (payload) {
        holidayPeriodStatus = payload.isInHolidayPeriod;
        contractStartDate = payload.to;
        quickPaymentLink = payload.quickPaymentUrl;
      }
      this.setState({ holidayPeriodStatus, contractStartDate, quickPaymentLink });
      frontEndLogs('Successfully retrieved contract for user', false, 200, 'getHolidayPeriod', holidayPeriodDetails.data.message || '');
      analyticsClickEvent('successfully_retrieved_contract_for_user', '');
    } else {
      this.setState({ holidayPeriodStatus: false });
      frontEndLogs('There is no contract available to this user', false, 400, 'getHolidayPeriod', holidayPeriodDetails.data.message || '');
      analyticsClickEvent('no_contract_available_for_user', '');
    }
    console.log(specificContractDetails);
  
    this.setState({ isLoading: false });
    let contractDetails = [];
    let contractSchedule = [];
    let nextPayment = [];
    let transactionHistory = [];
    sessionStorage.setItem('getScheduleContractDetails','');

    if(specificContractDetails.status === 400){
      if(Array.isArray(specificContractDetails.data.data.contract_schedule) && specificContractDetails.data.data.contract_schedule.length===0){
        sessionStorage.setItem('getScheduleContractDetails',specificContractDetails.data.message)
      }
    }
    if (specificContractDetails.status === 200) {
      this.setState({ isLoading: false });
      let constractSheduleLength = specificContractDetails.data.data.contract_schedule.length;
      let paidStatusCount = 0;
      let contractPaymentLink = specificContractDetails?.data?.data?.contract_details?.[0]?.payment_link || "";
      let contractLoanStatus = specificContractDetails?.data?.data?.contract_details?.[0]?.contract_status || "";
      let contractNextInstallmentDate = specificContractDetails?.data?.data?.contract_details?.[0]?.next_installment_date;
      let loanOldestDueDate = specificContractDetails?.data?.data?.contract_details?.[0]?.last_loan_duedate;
      let reserveDueAmount = specificContractDetails?.data?.data?.contract_details?.[0]?.reserve_due_amount;
      let apsTransactionAmount = specificContractDetails?.data?.data?.contract_details?.[0]?.aps_transaction_amount;
      let todayDate = specificContractDetails?.data?.data?.contract_details?.[0]?.today_date;
      let latestTransactionDate = specificContractDetails?.data?.data?.contract_details?.[0]?.last_transaction_gateway_date;
      let isLatestTransactionAdvancePayment = specificContractDetails?.data?.data?.contract_details?.[0]?.advance_payment;
      let { isEarlyPaymentDisabled, earlyPaymentMessage } = this.checkEarlyPaymentEligibility(loanOldestDueDate, todayDate, reserveDueAmount, apsTransactionAmount, latestTransactionDate, isLatestTransactionAdvancePayment);
      this.setState({
        paymentLink: contractPaymentLink,
        loanStatus: contractLoanStatus,
        nextInstallmentDate: contractNextInstallmentDate,
        isEarlyPaymentDisabled, earlyPaymentMessage
      });
      specificContractDetails.data.data.contract_details.map((response) => {
        contractDetails.push(response);
      });
      specificContractDetails.data.data.contract_schedule.map((schedule) => {
        if (schedule.status__c === "Paid") {
          paidStatusCount++;
        }
        let datadetails = {
          paymentStatus: schedule.status__c,
          paymentAmount: schedule.due_amount,
          paymentDate: schedule.due_date,
          paymentLink:schedule.payment_link,
          contractpayment_schedule_id: schedule.contractpayment_schedule_id,
        };
          contractSchedule.push(datadetails);
        let nextpaydata = {
          paymentAmount: schedule.due_amount,
          payDate: schedule.due_date,
          contractpayment_schedule_id: schedule.contractpayment_schedule_id,
          paymentStatus: schedule.status__c
        };

        nextPayment.push(nextpaydata);
      });
      specificContractDetails.data.data.transaction_history.map((transaction) => {
        let transactionData = {
           transactionAmount: transaction.amount__c,
           transactionDate: transaction.gateway_date__c,
           transactionStatus: transaction.status__c
        }
        transactionHistory.push(transactionData);
      });
      this.setState({ isLoading: false });
      let contractbal = (paidStatusCount / constractSheduleLength) * 100;
      let convertednextPaymentDetailData = this.sortData(nextPayment, { paymentStatus: 'asc' });
      this.setState({
        contractDataDetails: contractDetails,
        contractScheduleDetails: contractSchedule,
        transactionHistoryDetails: transactionHistory,
        nextPaymentDetails: nextPayment,
        convertednextPaymentDetails: convertednextPaymentDetailData,
        value: Math.round(contractbal)
      });
      $("#myRange").css({ 'backgroundImage': `linear-gradient(90deg, #ff6200 ${this.state.value}%, transparent ${this.state.value}%)` })
    } else if (specificContractDetails.status === 500) {
      this.setState({ isLoading: false });
      this.goBack();
    }

    if (specificContractDetails.status === 400) {
      this.goBack();
    }

    setTimeout(async() => {
      this.userCardDetails();
    }, 300);

  };

  getNextPaymentDue=(data)=>{
    const reserveDueAmount= Number(data.reserve_due_amount);
    const apsTransactionAmount = Number(data.aps_transaction_amount);
    const nextInstallmentDate = data.next_installment_date;
    if(reserveDueAmount<apsTransactionAmount){
      return nextInstallmentDate;
    }
    if(reserveDueAmount===apsTransactionAmount){
      const nextDate=new Date(nextInstallmentDate);
      nextDate.setMonth(nextDate.getMonth()+1);
      return nextDate.toLocaleDateString("en-US",{day: "numeric",month: "long",year: "numeric"});
    }
    if(reserveDueAmount>apsTransactionAmount){
      return "Refer to Email";
    }
  }

    checkEarlyPaymentEligibility = (loanOldestDueDate, todayDate, reserveDueAmount, apsTransactionAmount, latestTransactionDate, isLatestTransactionAdvancePayment) => {
        let isEarlyPaymentDisabled = false;
        let earlyPaymentMessage = '';
        const todaySystemDate = new Date(todayDate);
        todaySystemDate.setHours(0, 0, 0, 0);
        const dueDate = new Date(loanOldestDueDate);
        dueDate.setHours(0, 0, 0, 0);
        const latestTransaction = new Date(latestTransactionDate);
        latestTransaction.setHours(0, 0, 0, 0);
        const dueDateTodayorTomorrow = (todaySystemDate - dueDate) / (1000 * 60 * 60 * 24);
        const isAdvancePayment = latestTransaction && isLatestTransactionAdvancePayment && latestTransaction.getTime() == todaySystemDate.getTime();

        if (isAdvancePayment) {
            isEarlyPaymentDisabled = true;
            earlyPaymentMessage = 'Early payment has already been made for your next payment';
        }

        if (reserveDueAmount >= apsTransactionAmount) {
            isEarlyPaymentDisabled = true;
            earlyPaymentMessage = 'Early payment has already been made for your next payment';
        }

        if (loanOldestDueDate) {

            if ((dueDateTodayorTomorrow == 0) || (dueDateTodayorTomorrow == 1)) {
                isEarlyPaymentDisabled = true;
                earlyPaymentMessage = 'Early payment is not available as your next payment due is today or tomorrow';
            }
        }
        return { isEarlyPaymentDisabled, earlyPaymentMessage };
    }

  userCardDetails = async() => {
    const userCardDetails = await getCardsDetails(getUserContext());

    if(userCardDetails !== undefined){
    if (userCardDetails.data.statusCode === 200) {
      let hasActiveCardsArray = [];
      userCardDetails.data.data.map((response) => {
          let dataObject = {
            cardId: response.hummuk_customer_card_detail_id,
            cardNumber: response.hummuk_customer_card_detail_card_number__c,
            cardExpiryMonth: response.hummuk_customer_card_detail_exp_month,
            cardExpiryYear: response.hummuk_customer_card_detail_exp_year,
            PaymentMethodId: response.hummuk_customer_card_detail_payment_method_id__c,
            cardHoldName: response.hummuk_customer_card_detail_card_holder_name__c,
            cardStatus: response.hummuk_customer_card_detail_primary_card__c,
            cardType:response.hummuk_customer_card_detail_card_type__c.toLowerCase()
          };
        hasActiveCardsArray.push(dataObject);
      });

      this.setState({ hasActiveCards: hasActiveCardsArray }, () => {

        for(const [i,value] of this.state.hasActiveCards.entries()){
          if(value.cardStatus === true){
            console.log(value.cardStatus, value.cardNumber, i);
            this.setState({primaryCardNumber: value.cardNumber});
          }
        }
      });
    }

  }
  }

  redirectToAddCardTab = (event) => {
    event.preventDefault();
    window.$("#earlyPayment").modal("hide")
    sessionStorage.setItem('forwardRoute', '/wallet');
    this.props.navigate('/wallet');
  }

  makePayment = async (contractScheduleID) => {
    analyticsClickEvent('makepayment', '')
    const {loanStatus,paymentLink}=this.state;
    if(loanStatus && loanStatus!=='Active - Good Standing')
    {
      analyticsClickEvent('additional-payment','');
      if(paymentLink){
        window.open(paymentLink,'_blank');
      }
      window.$('#additionalPayment').modal('show');
      return;
    }
    this.setState({contractScheduleID: contractScheduleID })
    this.setState((prevState) => ({
      paymentAmount: prevState.contractDataDetails[0].aps_transaction_amount,
      selectedPaymentType: "",
      currentBalanceAmount: prevState.contractDataDetails[0].loan_payoff_amount,
      payDate: prevState.contractDataDetails[0].next_installment_date,
    }), () => {window.$("#makePayment").modal("show")});
  };

  handlePaymentSelect=(paymentType)=>{
    this.setState({selectedPaymentType:paymentType})
  }

  handleMakePaymentClose = () => {
    this.setState({ selectedPaymentType: null, isLoading: false });
  };

  handleConfirmPayment = () => {
    const { selectedPaymentType, paymentLink } = this.state;
    window.$('#makePayment').modal('hide');
    if (selectedPaymentType === "early-payment") {
      analyticsClickEvent('early-payment', '')
      window.$('#earlyPayment').modal('show');
    }
    else {
      analyticsClickEvent('additional-payment', '')
      if (paymentLink) {
        window.open(paymentLink, "_blank")
      }
      window.$('#additionalPayment').modal('show');
	}
  }

  handleEarlyPaymentSuccess=()=>{
    window.$("#earlyPaymentSuccess").modal("hide");
    this.initialLoad();
  }

  handleEarlyPaymentUnsuccessful=()=>{
    window.$("#earlyPaymentFailure").modal("hide");
    this.initialLoad();
  }

  formatDate = (transactiondate) => {
    const date = new Date(transactiondate);
    return date.toLocaleDateString("en-US", {month: "short",day: "2-digit",year: "numeric"});
  };

  paymentConfirm = async () => {
    this.setState({isLoading:true});
    const objs = {
      amount: Number.parseFloat(this.state.contractDataDetails[0].aps_transaction_amount,10),
      contract_id: this.state.contractId,
      contractpayment_schedule_id: this.state.contractScheduleID,
      ...getUserContext()
    };
    analyticsClickEvent('early_payment_confirm', this.state.contractScheduleID)
    const results = await CreatePaymentIntent(objs);
    this.setState({ isLoading: false });
    window.$("#earlyPayment").modal("hide");
    if (results) {
      if (results.data.statusCode===200 || results.data.statusCode===201) {
        this.setState({ 
          paymentSuccessMessage: results.data.message,
          transactionAmount:results.data.data.amount__c,
          transactionDate:results.data.data.gateway_date__c
        });
        window.$("#earlyPaymentSuccess").modal("show");
      } else {
        this.setState({
          paymentFailureMessage:results.data.message
        })
        window.$("#earlyPaymentFailure").modal("show");
      }
    }
  };

  sortData = (data, orderBy) => {
    if (Array.isArray(data) && data.length != 0) {
      orderBy = Array.isArray(orderBy) ? orderBy : [orderBy];
      return data.sort((a, b) => {
        let checkResult =  this.checkAllKeysInSortData(orderBy,a,b);
        if(checkResult === 0){
          return 0;
        }else{
          return checkResult;
        }
      });
    }
  }

  checkAllKeysInSortData = (orderBy,a,b) => {
    for (let i = 0, size = orderBy.length; i < size; i++) {
      const key = Object.keys(orderBy[i])[0],
        o = orderBy[i][key],
        valueA = a[key],
        valueB = b[key];
      if (!(valueA || valueB)) {
        console.error("the objects from the data passed does not have the key '" + key + "' passed on sort!");
        return 0;
      }
      let checkKeyResult =  this.checkKeyInSortData(valueA,valueB,o);
      if(checkKeyResult){
        return checkKeyResult;
      }
    }
  }

  checkKeyInSortData = (valueA,valueB,o) => {
    if (+valueA === +valueB) {
      return o.toLowerCase() === 'desc' ? valueB - valueA : valueA - valueB;
    } else if (valueA.localeCompare(valueB) > 0) {
        return o.toLowerCase() === 'desc' ? -1 : 1;
      } else if (valueA.localeCompare(valueB) < 0) {
        return o.toLowerCase() === 'desc' ? 1 : -1;
      }
  }

  quickPayment = () => {
    const { quickPaymentLink } = this.state;
    if (quickPaymentLink) {
      window.open(quickPaymentLink, '_blank');
    }
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to="/wallet" state={{ noContractMsg: 'msg' }} />;
  }

  const contractStartDate = this.state.contractStartDate;
  const formattedDate = formatDateToDDMMYY(contractStartDate);
  const holidayPeriodCondition = this.state.holidayPeriodStatus;
  const hasPaymentype=Boolean(this.state.selectedPaymentType);
  
    return (
      <div className="page-layout">
        <div className="wrapper wallet-contract-wrapper">
          <Loader loaderStatus={this.state.isLoading} />
          <section className="main">
            <div className="row">
              <div className="col-12">
                <div className="wallet---itemQr">
                  <div className="container">
                    <div className="wallet-container custom-wallet-banner-ses">
                      <div className="lr-item--hero">
                        <div className="hero-left">
                          {this.state.contractDataDetails !== "" && (
                            <div className="hero-left-top">
                              <div className="col-lg-5 col-md-6 user-info">
                                <div className="d-flex align-items-center wallet-top-item">
                                  <div className="user-image-area contract-details-profile">
                                    <IndustryImage
                                      src={this.state.contractDataDetails[0].account_cover}
                                      industryName={this.state.contractDataDetails[0].account_name}
                                    />
                                  </div>
                                  <div className="user--detailQwe detail-contract-grt">
                                    <h2>
                                      {
                                        this.state.contractDataDetails[0]
                                          .contract_name
                                      }
                                    </h2>
                                    <p>
                                      Start Date:{" "}
                                      {
                                        this.state.contractDataDetails[0]
                                          .contract_start_date
                                      }
                                    </p>
                                    <p>
                                      Retailer:{" "}
                                      {
                                        this.state.contractDataDetails[0]
                                          .account_name
                                      }
                                    </p>
                                    <p>
                                      Retailer reference:{" "}
                                      {
                                        this.state.contractDataDetails[0].
                                        retailer_reference?.slice(15)
                                      }
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-7 col-md-6 pr-5 pt-5 user-expense wallet-expense-item">
                                <div className="total-to-spend">
                                  <h6>Amount financed</h6>
                                  <h2>
                                    £
                                    {
                                      this.state.contractDataDetails[0]
                                        .total_loan_amount
                                    }
                                  </h2>
                                </div>
                                <div>
                                    <h6 className="balance-outstanding">Balance outstanding</h6>
                                    <h2 className="wallet-font-style">
                                    £
                                    {
                                      this.state.contractDataDetails[0]
                                        .loan_payoff_amount
                                    }
                                  </h2>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="back-btn">
                      <button
                        className="go-back-btn"
                        type="button"
                        onClick={(e) => this.goBack(e)}
                      >
                        <img src="images/arrow-back.svg" alt="back" className="arrow-back" /> Back
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="contract--summary">            
            {this.state.contractDataDetails !== "" && (
                <div className="contract-summary-details">
                    <div className="contract-summary-item">
                        <h6>Status</h6>
                        <p>{this.state.contractDataDetails[0].contract_status}</p>
                    </div>
                    <div className="contract-summary-item">
                        <h6>Repayment amount</h6>
                        <p>£{this.state.contractDataDetails[0].aps_transaction_amount}</p>
                    </div>
                    <div className="contract-summary-item">
                        <h6>Next payment due</h6>
                        <p>{this.getNextPaymentDue(this.state.contractDataDetails[0])}</p>
                    </div>
                </div>
            )}
          </section>
          <section className="contract--item">
            <div className="container">
              <div className="payment-schedule">
                {!holidayPeriodCondition}
                <div className={holidayPeriodCondition ? "holiday-period" : "row"}>
                  {!holidayPeriodCondition && (
                    <div className="col-lg-4 col-md-12 col-12 d-flex justify-content-center">
                      {this.state.nextPaymentDetails && 
                        <button 
                        className="make-a-payment-btn"
                        type='button'
                        onClick={() => {
                            this.makePayment(this.state.convertednextPaymentDetails[0].contractpayment_schedule_id);
                        }}
                      >
                      <img src='images/payment-logo.svg' alt='payment-logo' className="payment-logo"/>
                      {" "}Make a Payment
                      </button>
                    }
                    </div>
                  )}
                  <div className={holidayPeriodCondition ? "holiday-card" : "col-lg-4 col-md-12 col-12"}>
                    <div className="payment---Eqf table--item transaction-card">
                      <div className="transaction-header">
                        <h4>Transaction History</h4>
                        <p>All successful payments made to loan are shown below</p>
                      </div>
                      <div className="transaction-scroll">
                       {this.state.transactionHistoryDetails && this.state.transactionHistoryDetails.length>0?(
                            <table className="table transaction-table">
                            <tbody>
                              {this.state.transactionHistoryDetails !== "" &&
                              this.state.transactionHistoryDetails.map(
                                (details) => (
                                  <tr key={details.id}>
                                    <td className="transaction-date">
                                        {details.transactionDate}
                                    </td>
                                    <td className="transaction-amount">
                                      £{details.transactionAmount}
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                        </table>
                       ):(
                           <div className="no-transaction-history">
                               <img src="images/calendar-logo.svg" className="no-transaction-logo" alt="calendar-logo" />
                               <p>No payments yet</p>
                           </div>
                       )}
                      </div>
                    </div>
                  </div>
                  <div className={holidayPeriodCondition ? "holiday-card" : "col-lg-4 col-md-12 col-12"}>
                    { !holidayPeriodCondition ? (
                      <div className="progress-section d-none d-lg-block">
                      <h3>My Progress</h3>
                      <div className="slidecontainer">
                        <input
                          className="progress--slider paynow-disable"
                          id="myRange"
                          type="range"
                          min="0"
                          max="100"
                          value={this.state.value}
                          onChange={this.handleRangeChange}
                          step="1"
                        />
                        <p>
                          <span id="demo"></span>
                          {this.state.value} %
                        </p>
                        <div className="humm--logo">
                          <img
                            src="images/progress-logo.svg"
                            alt="logo"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                    </div>
                    ): (
                      <div>
                        {
                          <div className="quick-pay-section">
                              <p className="quick-pay-text">
                                Your monthly payments start after your deferral period ends. Payments include the amount you borrowed plus the interest added daily since the loan began. 
                                <br /><br />
                                If you pay off the full loan amount of
                                £{this.state.contractDataDetails && this.state.contractDataDetails.length > 0 ? this.state.contractDataDetails[0].total_loan_amount : '0'}
                                &nbsp;before the deferral period ends on <b>{formattedDate}</b>, we won’t charge you any of that interest.
                                <br /><br />
                              
                              You can also make a part payment at any time - this will lower your loan balance and reduce the total amount of interest you pay.
                          </p>
                          <button
                            type="button"
                            className="quick-pay-btn-text paynow-btn make-a-payment"
                            onClick={this.quickPayment}
                          >
                            Make a Payment
                          </button>
                          </div>
                        }
                      </div>
                    )}
                    </div>
                </div>
              </div>
              {/* <div className="Contract--Details">
                    <h3>Contract Details</h3>
                </div> */}
            </div>
          </section>
        </div>

        <div
          className="modal fade"
          id="manualPay"
          tabIndex="-1"
          aria-labelledby="manualPayTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" >
            <div className="modal-content">
              <div className="modal-header">
                <button
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="logo">
                  <img
                    src="images/modal-logo.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <div className="tittle-content">
                  <h2>Manual Payment</h2>
                  <p>
                    Please confirm that you wish to pay the below amount to
                    which will be deducted from your card ending ***49
                  </p>
                </div>
                <form>
                  <div className="form-group">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="£0.00"
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-toggle="modal"
                  data-target="#manualPayNext"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="manualPayNext"
          tabIndex="-1"
          aria-labelledby="manualPayNextTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" >
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="logo">
                  <img
                    src="images/modal-logo.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <div className="tittle-content">
                  <h2>Manual Payment</h2>
                  <p>
                    Please confirm that you wish to pay the below amount to
                    which will be deducted from your card ending ***49
                  </p>
                </div>
                <form>
                  <div className="form-group">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="£42.25"
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-toggle="modal"
                  data-target="#manualPayclose"
                >
                  Confrim
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="manualPayclose"
          tabIndex="-1"
          aria-labelledby="manualPaycloseTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" >
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="logo">
                  <img
                    src="images/modal-logo.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <div className="tittle-content mb-3">
                  <h2>Manual Payment</h2>
                  <p>
                    Thank you! Your payment has been confirmed and the amount
                    deducted from your balance.{" "}
                  </p>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* ther is no contract model */}
        <div
          className="modal fade"
          id="noContractModel"
          tabIndex="-1"
          aria-labelledby="noContractModelTitle"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered" >
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="logo">
                  <img
                    src="images/modal-logo.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <div className="tittle-content mb-3">
                  {/* <h2>Message</h2> */}
                  <p>
                    {this.state.noContractMsg}
                  </p>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>

        {/*Next Payment Modal */}

        <div
          className="modal fade"
          id="nextPay"
          tabIndex="-1"
          aria-labelledby="nextPaycloseTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" >
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="logo">
                  <img
                    src="images/modal-logo.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <div className="tittle-content mb-3">
                  <h2>Confirm Payment</h2>
                  <p className="mb-0">
                    Please confirm your payment £{this.state.paymentAmount}{" "}
                  </p>
                  <p className="mt-2 nextPay--card-number-text">from your primary card ending in {this.state.primaryCardNumber}</p>
                </div>
              </div>
              <div className="modal-footer nextPay-popup">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    this.paymentConfirm();
                  }}
                >
                  Confirm
                </button>
              </div>
              <div className="text-center">
                <button onClick={(e)=>{e.preventDefault();this.redirectToAddCardTab()}} className="nextPay--change-primary-card btn-style">Change Primary Card</button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="makePayment"
          tabIndex="-1"
          aria-labelledby="makePaymentTitle"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content make-payment-content">
                <div className="make-payment-header">
                  <h6>Make a Payment</h6>
                  <p>Choose a payment method | current balance: £{this.state.currentBalanceAmount}</p>

                  <div className="payment-method">
                    Payment Method :{" "}
                     <span className="card-detail">
                      <img src="images/card-icon.svg" alt="card-icon" className="card-icon"/>
                      Visa .... {this.state.primaryCardNumber}
                     </span>
                  </div>
                </div>

                <label 
                  className={`make-payment-option ${this.state.selectedPaymentType==="early-payment"?"selected-payment":""}
                  ${this.state.isEarlyPaymentDisabled?"early-payment-disabled":""}
                  `}
                  aria-label="early_payment"
                >
                   <input
                      type="radio"
                      name="paymentType"
                      value="early-payment"
                      checked={this.state.selectedPaymentType === "early-payment"}
                      disabled={this.state.isEarlyPaymentDisabled}
                      onChange={()=>this.handlePaymentSelect("early-payment")}
                      className="payment-radio-button"
                   />
                   <div className="early-payment-option">
                      <h5>Early Payment</h5>
                      <p>Make your next payment of £{this.state.paymentAmount} ahead of <br />time</p>
                   </div>
                </label>

                {this.state.isEarlyPaymentDisabled && this.state.earlyPaymentMessage&&(
                    <div className="early-payment-message">
                        {this.state.earlyPaymentMessage}
                    </div>
                )}

                <label 
                  className={`make-payment-option ${this.state.selectedPaymentType==="additional-payment"?"selected-payment":""}`}
                  aria-label="additional_payment"
                >
                   <input
                      type="radio"
                      name="paymentType"
					  value="additional-payment"
                      checked={this.state.selectedPaymentType === "additional-payment"}
                      onChange={()=>this.handlePaymentSelect("additional-payment")}
                      className="payment-radio-button"
                   />
                   <div className="additional-payment-option">
                      <h5>Additional Payment</h5>
                      <p>Make an additional payment</p>
                   </div>
                </label>

                <div className="make-payment-actions">
                    <button 
                      type='button'
                      className={`make-payment-confirm-button ${hasPaymentype ?"" : "disabled-button"}`}
                      disabled={!hasPaymentype}
                      onClick={this.handleConfirmPayment}
                    >
                      Confirm
                    </button>
                    <button 
                      type="button"
                      className="make-payment-cancel-button"
                      data-dismiss="modal"
                      aria-label="Close" 
                      onClick={this.handleMakePaymentClose}
                    >
                      Cancel
                    </button>
                </div>
            </div>
          </div> 
        </div>

        <div
          className="modal fade"
          id="earlyPayment"
          tabIndex="-1"
          aria-labelledby="earlyPaymentTitle"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered">
             <div className="modal-content early-payment-content">
               <div className="early-payment-header">
                 <h6>Confirm Early Payment</h6>
                 <p>Please Confirm you wish to pay your <br/>monthly payment of £{this.state.paymentAmount} now</p>
                 <p>Once Successful payment is <br/> complete, you will not be debited on <br/> next due date; {this.state.payDate}</p>
                 <div className="early-payment-method">
                    Payment Method :{" "}
                     <span className="card-detail">
                      <img src="images/card-icon.svg" alt="card-icon" className="card-icon"/>
                      Visa .... {this.state.primaryCardNumber}
                     </span>
                     <button type="button" onClick={this.redirectToAddCardTab} className="change-card">Change</button>
                  </div>
               </div>
               <div className="early-payment-actions">
                    <button 
                      type='button'
                      className="early-payment-confirm-button"
                      onClick={() => {this.paymentConfirm()}}
                    >
                      Confirm
                    </button>
                    <button 
                      type="button"
                      className="early-payment-cancel-button"
                      data-dismiss="modal"
                      aria-label="Close" 
                      onClick={this.handleMakePaymentClose}
                    >
                      Cancel
                    </button>
                </div>
             </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="additionalPayment"
          tabIndex="-1"
          aria-labelledby="additionalPaymentTitle"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered">
             <div className="modal-content additional-payment-content">
               <div className="additional-payment-header">
                 <h6>Additional Payment Selected</h6>
                 <p>A link to your payment has been <br/> opened in a new tab</p>
                 <p>If it does not open please ensure <br/> pop-up blockers are disabled</p>
               </div>
               <div className="additional-payment-actions">
                  <button
                    type="button"
                    className="additional-payment-close-button"
                    data-dismiss="modal"
                    aria-label="Close" 
                    onClick={this.handleMakePaymentClose}
                  >
                  Close
                  </button>
               </div>
             </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="earlyPaymentSuccess"
          tabIndex="-1"
          aria-labelledby="earlyPaymentSuccessTitle"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content early-payment-success-content">
                <div className="early-payment-success">
                  <img src='images/Success-logo.svg' alt='success-logo' className="success-logo"/>
                  <h6>Payment Successful</h6>
                </div>
                <div className="payment-transaction-summary">
                   <div className="payment-transaction-summary-list">
                      <span>Amount Paid</span>
                      <span>£{this.state.transactionAmount}</span>
                   </div>
                   <div className="payment-transaction-summary-list">
                      <span>Payment Method</span>
                      <span>
                      <img src="images/card-icon.svg" alt="card-icon" className="card-icon"/>
                      .... {this.state.primaryCardNumber}
                      </span>
                   </div>
                   <div className="payment-transaction-summary-list">
                      <span>Transaction Date</span>
                      <span>{this.formatDate(this.state.transactionDate)}</span>
                   </div>
                </div>
                <div className="early-payment-success-message">
                  <p>{this.state.paymentSuccessMessage}</p>
                </div>
                <div className="early-payment-success-done">
                  <button
                    type="button"
                    className="early-payment-success-button"
                    data-dismiss="modal"
                    aria-label="done" 
                    onClick={this.handleEarlyPaymentSuccess}
                  >
                  Done
                  </button>
               </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="earlyPaymentFailure"
          tabIndex="-1"
          aria-labelledby="earlyPaymentFailureTitle"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content early-payment-failure-content">
              <div className="early-payment-failure">
                <h6>Payment Unsuccessful</h6>
              </div>

              <div className="early-payment-failure-message">
                <p>{this.state.paymentFailureMessage}</p>
              </div>

              <div className="early-payment-failure-close">
                <button
                  type="button"
                  className="early-payment-failure-button"
                  data-dismiss="modal"
                  aria-label="close"
                  onClick={this.handleEarlyPaymentUnsuccessful}
                >
                Close
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="nextPaySuccess"
          tabIndex="-1"
          aria-labelledby="nextPaySuccesscloseTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" >
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="logo">
                  <img
                    src="images/modal-logo.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <div className="tittle-content mb-3">
                  <h2>Payment Status</h2>
                  <p>{this.state.paymentSuccessMessage}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

WalletContract.propTypes = {
  navigate: PropTypes.object,
  location: PropTypes.object,
}

export default withRouter(WalletContract);
